import { render } from "./goods-footer.vue?vue&type=template&id=607e2a81&scoped=true"
import script from "./goods-footer.vue?vue&type=script&lang=js"
export * from "./goods-footer.vue?vue&type=script&lang=js"

import "./goods-footer.vue?vue&type=style&index=0&id=607e2a81&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-607e2a81"

export default script